export default __webpack_public_path__ + "static/media/close-filter.f5fbd44f.svg";